var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectVersionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1345 4.94727H5.81455C5.33722 4.94727 4.94922 5.33526 4.94922 5.8126V11.1326C4.94922 11.6099 5.33722 11.9979 5.81455 11.9979H11.1345C11.6119 11.9979 11.9999 11.6099 11.9999 11.1326V5.8126C11.9999 5.3366 11.6119 4.94727 11.1345 4.94727ZM5.81455 11.1339V5.81393H11.1345V11.1339H5.81455Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47461 3.77327V10.3306H3.33994V3.77327C3.33994 3.53461 3.53461 3.33994 3.77327 3.33994H10.3306V2.47461H3.77327C3.05728 2.47461 2.47461 3.05728 2.47461 3.77327Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.865332 1.29866C0.865332 1.06 1.06 0.865332 1.29866 0.865332H8.47332V0H1.29866C0.582666 0 0 0.582666 0 1.29866V8.47332H0.865332V1.29866Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectVersionIcon);
export default __webpack_public_path__ + "static/media/select_version_icon.7271a960bebfaeabe45a488cc2f6b06d.svg";
export { ForwardRef as ReactComponent };